import "./about.css";

export function About() {
	return (
		<div>
			<h1>À Propos</h1>
			<p>
				Ce TP a été réalisé par{" "}
				<a href="https://finxol.io" target="_blank" rel="noopener noreferrer">
					Colin Ozanne
				</a>
				, étudiant à l'ISTIC – Université de Rennes.
			</p>
		</div>
	);
}
